<template>
  <b-card
      class="mb-3"
      no-body
  >
    <template #header>
      <div class="d-flex">
        {{ $t('Overview') }}

        <b-button
            v-if="!lazy"
            :disabled="pending"
            class="ml-auto"
            @click="fetchData"
        >
          <fa :spin="pending" icon="sync" />
        </b-button>
      </div>
    </template>


    <b-card-body>
      <spinner v-if="pending" />

      <div v-if="lazy" class="text-center">
        <b-button @click="fetchData">
          {{ $t('Load data') }}
        </b-button>
      </div>


      <b-pagination
          v-if="showPagination"
          v-model="currentPage"
          :disabled="pending"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          class="mt-0"
      />

      <floor-overview-room
          v-for="room in items"
          :key="`room-overview_${room.id}`"
          :component-id="+componentId"
          :floor-id="+floorId"
          :project-id="+projectId"
          :room="room"
          @input="updateRoom(room, $event)"
      />

      <b-pagination
          v-if="showPagination"
          v-model="currentPage"
          :disabled="pending"
          :per-page="perPage"
          :total-rows="totalRows"
          align="center"
          class="mb-0"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import Spinner from "@/components/Spinner";
import fetchPaginatedData from "@/mixins/fetchPaginatedData";
import FloorOverviewRoom from "@/components/floors/FloorOverviewRoom";

export default {
  name: 'FloorOverview',
  components: {FloorOverviewRoom, Spinner},
  mixins: [fetchPaginatedData],
  props: {
    projectId: {
      type: [Number, String],
      required: true,
    },
    componentId: {
      type: [Number, String],
      required: true,
    },
    floorId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      params: {
        service_id: null
      },
      lazy: true
    }
  },
  computed: {
    apiUrl() {
      return `/api/projects/${this.projectId}/components/${this.componentId}/floors/${this.floorId}/overview`;
    },
  },
  created() {
    this.$root.$on('created::room', this.pushData);
  },

  beforeDestroy() {
    this.$root.$off('created::room', this.pushData);
  },

  methods: {
    hidePopover(event) {

    },
    setData(data) {
      this.items = data.data || data;
      this.meta = data.meta || {};
      this.perPage = data.per_page || this.meta.per_page
      this.totalRows = data.total || this.meta.total
    },

    pushData(data) {
      this.items.push(data);
      this.totalRows = this.totalRows + 1;
    },

    updateRoom(room, data) {
      this.$set(this.items, this.items.indexOf(room), data);
    }
  },
};
</script>
